import { BDEPermissions } from './BDEPermissions';
import { IMRPermission } from './IMRPermissions';
import { KAEPermissions } from './KAEPermissions';
import { TSIPermission } from './TSIPermissions';
import { KAESSPermissions } from './KAESSPermission';
import { RBDMPermissions } from './RBDMPermissions';
import { SSPermissions } from './SSPermissions';
import { BDESEPermissions } from './BDESEPermissions';
import { RCIPermissions } from './RCIPermissions';

export type Role = 'BDE' | 'IMR' | 'TSI' | 'KAE' | 'KAESS' | 'SS' | 'BDE SE' | 'RBDM' | 'RCI';

export interface IPermissionModel {
	name: string;
	route: string;
	components: string[];
}

export const RBAC_MODEL: Record<Role, IPermissionModel[]> = {
	BDE: BDEPermissions,
	IMR: IMRPermission,
	TSI: TSIPermission,
	KAE: KAEPermissions,
	KAESS: KAESSPermissions,
	RBDM: RBDMPermissions,
	SS: SSPermissions,
	'BDE SE': BDESEPermissions,
	RCI: RCIPermissions,
};
